export const steps = [
  {
    number: '01',
    title: 'Znajdź produkt',
    description: 'Przeglądaj kategorie i wybierz interesujący Cię produkt z naszej listy. Filtruj według typu, marki lub popularności.',
    icon: 'ri-search-line',
  },
  {
    number: '02',
    title: 'Sprawdź informacje',
    description: 'Zapoznaj się ze szczegółami produktu, zdjęciami, opisem i opiniami innych użytkowników przed podjęciem decyzji.',
    icon: 'ri-file-search-line',
  },
  {
    number: '03',
    title: 'Porównaj opcje',
    description: 'Porównaj podobne produkty pod kątem ceny, jakości i opinii. Wybierz najlepszą ofertę dopasowaną do Twoich potrzeb.',
    icon: 'ri-scales-line',
  },
  {
    number: '04',
    title: 'Przejdź do zakupu',
    description: 'Kliknij link i przejdź bezpośrednio do strony produktu, aby sfinalizować zakup w bezpieczny sposób.',
    icon: 'ri-shopping-cart-line',
  },
];